import { cn } from "@/lib/cn";

type Props = {
  active?: boolean;
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
  as?: "button" | "span";
};

export default function Chip({ active, className, children, onClick, as = "button" }: Props) {
  const classes = cn(
    "inline-flex items-center gap-2 rounded-[var(--radius-pill)] border px-3.5 py-1.5 text-sm transition-colors",
    active
      ? "border-[color:var(--color-primary)] bg-[color:var(--color-primary-soft)] text-[color:var(--color-primary-dark)]"
      : "border-[color:var(--color-border)] bg-[color:var(--color-surface)] text-[color:var(--color-text)] hover:border-[color:var(--color-border-strong)]",
    className,
  );

  if (as === "span") {
    return <span className={classes}>{children}</span>;
  }
  return (
    <button type="button" className={classes} onClick={onClick}>
      {children}
    </button>
  );
}
